import { getInterviewSectionTopic } from "@repo/app-types/entities/interviewSection/definition";
import type { FC } from "react";
import type { VisibleInterviewSectionDefinition } from "../interviewSections/definitions/state.js";

interface LessonItemTitleProps {
  section: VisibleInterviewSectionDefinition | undefined;
}

/** Displays the lesson title */
export const LessonItemTitle: FC<LessonItemTitleProps> = ({ section }) => {
  const topic = getInterviewSectionTopic(section?.settings);
  const title = topic ?? "Untitled lesson";

  return (
    <div className="flex flex-1 overflow-hidden" title={title}>
      {topic ? (
        <span className="truncate text-sm font-medium text-foreground">
          {topic}
        </span>
      ) : (
        <span className="truncate text-sm font-medium text-muted-foreground">
          Untitled lesson
        </span>
      )}
    </div>
  );
};
